import { useMemo } from "react";
import { MESSAGES_WIDGET_TYPE } from "ai/widget-summary/createMessagesWidgetSummaryRequest";
const useWidgetSummarySuggestedQuestions = (request) => {
  var _a;
  return useMemo(() => {
    var _a2, _b;
    const widgetName = (_a2 = request == null ? void 0 : request.payload.name) != null ? _a2 : "this widget";
    if (((_b = request == null ? void 0 : request.payload.config) == null ? void 0 : _b.type) === MESSAGES_WIDGET_TYPE) {
      return [
        `What stands out in ${widgetName}?`,
        "Which errors or failures appear?",
        "Which sources are the most active?"
      ];
    }
    return [`What stands out in ${widgetName}?`, "Summarize this widget", "Is this volume normal for this time range?"];
  }, [request == null ? void 0 : request.payload.name, (_a = request == null ? void 0 : request.payload.config) == null ? void 0 : _a.type]);
};
export default useWidgetSummarySuggestedQuestions;
